import React, { useState, useMemo } from 'react';
import { Dropdown, Checkbox, List } from 'tea-component';
import './index.scss';
import { MILESTONE_KEY_LIST, MILESTONE_CATEGORY_LIST } from '@gp/constants/const';
import { useDeepCompareEffect } from 'ahooks';

interface MilestoneLegendProps {
  timelines?: any;
  setMilestoneLegendList?: any;
  isAll?: any;
  setIsAll?: any;
}

const MilestoneLegend: React.FC<MilestoneLegendProps> = (props) => {
  const { timelines, setMilestoneLegendList, setIsAll } = props;

  const [milestoneLegendOptions, setMilestoneLegendOptions] =
    useState<any[]>(MILESTONE_CATEGORY_LIST);

  useDeepCompareEffect(() => {
    const list = timelines || [];
    const arrTemp = list?.map((item: any) => {
      return item.category;
    });
    const uniqueArray = [...new Set(arrTemp)];

    // 先判断三个主KEY中是否有
    const hasMainKey = uniqueArray.some((item: any) => MILESTONE_KEY_LIST.includes(item));

    const arr = MILESTONE_CATEGORY_LIST?.map((item) => {
      const isDisabled = !list.some((milestone: any) => milestone.category === item.key);
      let valueTemp = false;
      if (hasMainKey) {
        valueTemp = MILESTONE_KEY_LIST?.includes(item.key) && !isDisabled;
      } else {
        valueTemp = !MILESTONE_KEY_LIST?.includes(item.key);
      }
      return { ...item, disabled: isDisabled, value: valueTemp };
    });
    setMilestoneLegendOptions(arr);
  }, [timelines]);

  const handleClickItem = (milestone: any) => {
    const arrTemp = [...milestoneLegendOptions];
    const newArr = arrTemp?.map((item: any) => {
      let valueTemp = item.value;
      if (milestone?.key === item.key) {
        valueTemp = !item.value;
      }
      return {
        ...item,
        value: valueTemp,
      };
    });
    setMilestoneLegendOptions(newArr);
  };

  const isAllStatus = useMemo(() => {
    const arr = milestoneLegendOptions?.filter((item) => !item.disabled);
    return arr.every((item) => item.value === true);
  }, [milestoneLegendOptions]);

  const handleClickAll = () => {
    let valueTemp = true;

    if (isAllStatus) {
      valueTemp = false;
    }
    const arr = [...milestoneLegendOptions];
    const newArr = arr?.map((item: any) => {
      return {
        ...item,
        value: item.disabled ? false : valueTemp,
      };
    });
    setMilestoneLegendOptions(newArr);
  };

  const isIndeterminate = useMemo(() => {
    const arr = milestoneLegendOptions?.filter((item) => !item.disabled);
    const arrValue = milestoneLegendOptions?.filter((item) => item.value);
    const allTrue = arr.every((item) => item.value === true);
    return arrValue?.length > 0 && !allTrue;
  }, [milestoneLegendOptions]);

  const handleClose = (list = milestoneLegendOptions) => {
    // 关闭组件清空重置筛选关键字
    const arr = [...list];
    const arrDisList = arr?.filter((item) => !item.disabled) || [];
    const arrValue = arrDisList?.filter((item) => item.value);

    if (arrValue?.length > 0) {
      const newArr = arrValue?.map((item: any) => item?.key);
      setMilestoneLegendList?.(newArr);
      const isAllValue = arrDisList?.every((item) => item.value === true);
      setIsAll?.(isAllValue);
    } else {
      const newArr = arr?.map((item: any) => {
        return {
          ...item,
          value: !item.disabled,
        };
      });
      setMilestoneLegendOptions(newArr);

      const newArrList = arrDisList?.map((item: any) => item?.key);
      setMilestoneLegendList?.(newArrList);
      setIsAll?.(true);
    }
  };

  return (
    <Dropdown
      className="dbg-select-milestones-legend"
      clickClose={false}
      button="Milestone Legend"
      appearance="link"
      overlayClassName={'dbg-select-milestones-legend-overlay'}
      onClose={handleClose}
    >
      <List type="option">
        <List.Item onClick={handleClickAll} key={'all'}>
          <Checkbox
            display="block"
            value={isAllStatus}
            onClick={handleClickAll}
            indeterminate={isIndeterminate}
          >
            {'All'}
          </Checkbox>
        </List.Item>
        {milestoneLegendOptions?.map((item: any, index: number) => {
          return (
            <List.Item onClick={() => handleClickItem(item)} key={index} disabled={item.disabled}>
              <Checkbox
                display="block"
                value={item.value}
                onClick={() => handleClickItem(item)}
                disabled={item.disabled}
              >
                {item.text}
              </Checkbox>
              {item.icon && (
                <span className={`dbg-select-milestones-legend-icon-${item.icon}`}></span>
              )}
            </List.Item>
          );
        })}
      </List>
    </Dropdown>
  );
};

export default MilestoneLegend;
